import {
  Button,
  Flex,
  Switch,
  Table as ChakraTable,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { ArticlePollType, OlaggModule, PermissionEnum } from '@olagg/db-types'
import { generatePath, useNavigate } from 'react-router-dom'
import { ROUTES } from '../../consts/routes'
import useRoles from '../../features/Roles/hooks/useRoles'
import { archetypeLabels, sourceLabels } from './constants'

const Table = ({
  articlePolls,
  toggleActive,
}: {
  articlePolls: ArticlePollType[],
  toggleActive: (poll: ArticlePollType) => void,
}) => {
  const navigate = useNavigate()
  const { missingPermission } = useRoles()

  const review = (id: number) => navigate(generatePath(ROUTES.ARTICLE_POLLS.update, { id }))

  return (
    <TableContainer overflowX={'scroll'} overflowY={'scroll'} w='80vw' h='60vh' mt='12'>
      <ChakraTable variant='striped' colorScheme='olaggPurple' fontSize='16px' position='relative'>
        <Thead>
          <Tr position='sticky' bg='gray.800' top='0' zIndex='100'>
            <Th color='white'>Activa</Th>
            <Th color='white'>Artículo</Th>
            <Th color='white'>Tipo</Th>
            <Th color='white'>Origen</Th>
            <Th color='white'>Opciones vivas</Th>
            <Th color='white'>Votos</Th>
            <Th color='white'>Acción</Th>
          </Tr>
        </Thead>
        <Tbody>
          {articlePolls?.map(poll => (
            <Tr key={poll.id} _hover={{ color: 'cyan' }} cursor='pointer' onClick={() => review(poll.id)}>
              <Td onClick={e => e.stopPropagation()}>
                <Switch
                  isChecked={poll.active}
                  colorScheme='purple'
                  isDisabled={missingPermission(OlaggModule.ArticlePoll, PermissionEnum.EDIT)}
                  onChange={() => toggleActive(poll)}
                />
              </Td>
              <Td maxW='320px' whiteSpace='normal'>
                {poll.news?.title}
                <Text fontSize='xs' color='gray.400'>{poll.news?.slug}</Text>
              </Td>
              <Td>{archetypeLabels[poll.archetype] || poll.archetype}</Td>
              <Td maxW='200px' whiteSpace='normal'>
                {sourceLabels[poll.source] || poll.source}
              </Td>
              <Td>{poll.liveOptionsCount}</Td>
              <Td>{poll.totalVotes}</Td>
              <Td textAlign='center'>
                <Flex gap='3'>
                  <Button
                    size={'sm'} padding='0px 8px' colorScheme='green'
                    onClick={e => { e.stopPropagation(); review(poll.id) }}
                  >
                    Revisar
                  </Button>
                </Flex>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </ChakraTable>
    </TableContainer>
  )
}

export default Table
